export default { IN_PROGRESS: 'in-progress', SUCCESSFUL: 'successful', FAILED: 'failed' }
